<template>
  <div class="Dashbord">
    <FloatingButton></FloatingButton>
    <ActionsNav></ActionsNav>
    <div class="Actions__Content">
      <v-container fluid>
        <Breadcrumbs />
        <!-- /.Breadcrumbs -->
        <section class="TankRoom">
          <h2>
            <span>{{ this.nazivProstorije }}</span>
            <!-- <router-link
                to="/"
                class="moreInfo"
            >Više informacija
              <i class="fa fa-chevron-right"></i>
            </router-link> -->
          </h2>
          <div class="TankHolder">
            <div v-for="tank in items" :key="tank.tankId">
              <template v-if="tank.wine === null">
                <div
                  :class="'Tank '"
                  :id="tank.tankId"
                  :key="tank.tankId"
                  :data-tank-id="tank.tankId"
                  :data-tank-type="tank.tankTypeId"
                  :data-tank-phase-vine-id="tank.id"
                  :data-tank-quantity="tank.quantity"
                  :data-tank-phase="0"
                  :data-tank-phase-mark="0"
                  :data-phase-bottling=false
                  :data-wine-type="0"
                  :data-wine-id="0"
                  :data-tank-name="tank.tankName"
                  :data-unit-of-measure="0"
                  :data-tank-type-lable="tank.tankTypeEnumLable"
                  @click="selectTank(tank)"
                >
                  <div class="Tank__Bar">
                    <div class="bar">
                      <span
                        class="bar_Fill"
                        :style="
                          'height: ' +
                          (100 * tank.quantity) / tank.capacity +
                          '%'
                        "
                      ></span>
                      <span class="bar_Bkg"></span>
                    </div>
                  </div>
                  <!-- /.Tank__Bar -->
                  <div class="Tank__Content">
                    <p class="vineType">{{ $t("home.empty_tank") }}</p>
                    <h4>
                      <router-link
                        :to="{
                          name: 'empty_tank',
                          params: { id: tank.tankId },
                        }"
                      >
                        {{ tank.tankName }}
                      </router-link>
                    </h4>
                    <div class="Tank__Img">
                      <img
                        :src="'../assets/iconsTanks/' + tank.tankType + '.svg'"
                        alt="Tank Image"
                      />
                    </div>
                    <!-- /.Tank__Img -->
                    <div
                      class="Tank__Info"
                      v-if="
                        tank.tankType === 'barik' &&
                        tank.inventoryNumber !== null
                      "
                    >
                      <p
                        class="amauntAvailable"
                        style="color: #6d001a; font-weight: bold"
                      >
                        {{ tank.inventoryNumber }}
                      </p>
                    </div>
                    <div class="Tank__Info">
                      <p class="amauntAvailable">
                        0{{ tank.quantityUnitOfMeasure }} / {{ tank.capacity
                        }}{{ tank.capacityUnitOfMeasure }}
                      </p>
                      <span class="counter"
                        >{{ (100 * tank.quantity) / tank.capacity }}%</span
                      >
                    </div>
                    <!-- /.Tank__Info -->
                  </div>
                </div>
              </template>
              <template v-else>
                <div
                  :class="'Tank ' + tank.wineEnumLable"
                  :key="tank.tankId"
                  :id="tank.tankId"
                  :data-tank-id="tank.tankId"
                  :data-tank-type="tank.tankTypeId"
                  :data-tank-phase-vine-id="tank.id"
                  :data-tank-quantity="tank.quantity"
                  :data-tank-phase="tank.phaseId"
                  :data-tank-phase-mark="tank.phase"
                  :data-tank-phase-bottling="String(tank.phaseBottling)"
                  :data-wine-type="tank.wineTypeId"
                  :data-wine-id="tank.wineId"
                  :data-tank-name="tank.tankName"
                  :data-unit-of-measure="tank.quantityUnitOfMeasure"
                  :data-unit-of-measure-id="tank.quantityUnitOfMeasureId"
                  :data-vine-name="tank.wine"
                  :data-vine-year="tank.wine.year"
                  :data-tank-type-lable="tank.tankTypeEnumLable"
                  @click="selectTank(tank)"
                >
                  <div class="Tank__Bar">
                    <div class="bar">
                      <span
                        class="bar_Fill"
                        :style="
                          'height: ' +
                          (100 * tank.quantity) / tank.capacity +
                          '%'
                        "
                      ></span>
                      <span class="bar_Bkg"></span>
                    </div>
                  </div>
                  <!-- /.Tank__Bar -->
                  <div class="Tank__Content">
                    <!-- <p class="vineType">{{ tank.wine }}</p> -->

                    <p class="vineType" v-if="tank.wine === undefined"></p>
                    <p class="vineType" v-else-if="tank.wine.length <= 23">
                      {{ tank.wine }}
                    </p>
                    <p class="vineType" :title="tank.wine" v-else>
                      {{ tank.wine.substring(0, 20) }}...
                    </p>

                    <!-- <div class="columnVineType" style="">{{ tank.wine.wineLabel.name }} {{ tank.wine.year }}
                        <div class="columnRightVineType">{{tank.phase.phaseMark}}</div>
                        
                        </div> -->
                    <h4>
                      <router-link
                        :to="{
                          name: 'single_tank',
                          params: { id: tank.id, idTank: tank.tankId },
                        }"
                      >
                        {{ tank.tankName }}
                      </router-link>
                    </h4>

                    <div class="Tank__Img">
                      <img
                        :src="'../assets/iconsTanks/' + tank.tankType + '.svg'"
                        alt="Tank Image"
                      />
                    </div>
                    <div
                      class="Tank__Info"
                      v-if="
                        tank.tankType === 'barik' &&
                        tank.inventoryNumber !== null
                      "
                    >
                      <p
                        class="amauntAvailable"
                        style="color: #6d001a; font-weight: bold"
                      >
                        {{ tank.inventoryNumber }}
                      </p>
                    </div>
                    <!-- /.Tank__Img -->
                    <div class="Tank__Info">
                      <!-- <p class="amauntAvailable">Faza - {{tank.phase.phaseMark}}</p> -->
                      <p class="amauntAvailable">
                        {{ tank.quantity }}{{ tank.quantityUnitOfMeasure }} /
                        {{ tank.capacity }}{{ tank.capacityUnitOfMeasure }}
                      </p>
                    </div>
                    <div class="row">
                      <div class="column">
                        {{
                          parseFloat(
                            100 * (tank.quantity / tank.capacity)
                          ).toFixed(2)
                        }}%
                      </div>
                      <div class="columnRight">
                        {{ tank.phase }}
                        <div
                          class="columnRightVineType"
                          v-if="tank.desiredTemperature !== null"
                        >
                          {{ tank.desiredTemperature }}°C
                        </div>
                      </div>
                    </div>
                    <!-- /.Tank__Info -->
                  </div>
                </div>
              </template>

              <!-- /.Tank__Content -->
            </div>
            <!-- /.Tank -->
          </div>
          <!-- /.TankHolder -->
        </section>
        <!-- /.TankRoom -->
      </v-container>
    </div>
    <!-- /.Actions__Content -->
  </div>
  <!-- /.Dashboard -->
</template>

<script>
import { serverBus } from "../main";

import Breadcrumbs from "../components/layoutComponents/Breadcrumbs";
import ActionsNav from "./parts/ActionsNav";
import FloatingButton from "./parts/FloatingButton";

export default {
  name: "tankRoom",
  components: {
    Breadcrumbs,
    ActionsNav,
    FloatingButton,
  },
  data() {
    return {
      nazivProstorije: "",
      actionId: 0,
      items: [],
      all_grape_input_items: [],
      tank_phase_vineId: 0,
      tankId: 0,
      kolicina_vina_u_bacvi: 0,
      akcija: 0,
      floating_akcija: "2",
      idRoom: 0,
    };
  },
  methods: {
    selectTank: function (tank) {
      let rooms = document.getElementsByClassName("TankRoom");
      for (let i = 0; i < rooms.length; i++) {
        var pomInt = 9999;
        let tanks = rooms[i].getElementsByClassName("Tank");

        for (let i = 0; i < tanks.length; i++) {
          tanks[i].classList.remove("active");

          if (tanks[i].id == tank.tankId) {
            let presovanje;

            if (tank.tankType.indexOf("presa") >= 0) presovanje = false;
              else presovanje = true;

            if (tank.phase !== null) {
              let flasiranje;

              if (tank.phaseBottling) flasiranje = false;
              else flasiranje = true;

              let ulaz_grozdja;

              if (tank.phaseGrapeInput) ulaz_grozdja = false;
              else ulaz_grozdja = true;

              if (tank.phase === "AF") {
                let nizVrednosti = [
                  ulaz_grozdja,
                  ulaz_grozdja,
                  !presovanje,
                  false,
                  false,
                  false,
                  false,
                  flasiranje,
                  false,
                  false,
                  false,
                  true
                ];
                serverBus.$emit("disable_action", nizVrednosti);
              } else if (tank.phase === "MF") {
                let nizVrednosti = [
                  ulaz_grozdja,
                  ulaz_grozdja,
                  !presovanje,
                  false,
                  false,
                  false,
                  false,
                  flasiranje,
                  false,
                  false,
                  false,
                  true
                ];
                serverBus.$emit("disable_action", nizVrednosti);
              } else if (tank.phase === "AM") {
                let nizVrednosti = [
                  ulaz_grozdja,
                  ulaz_grozdja,
                  !presovanje,
                  false,
                  false,
                  false,
                  false,
                  flasiranje,
                  false,
                  false,
                  false,
                  true
                ];
                serverBus.$emit("disable_action", nizVrednosti);
              } else if (tank.phase === "OD") {
                let nizVrednosti = [
                  ulaz_grozdja,
                  ulaz_grozdja,
                  !presovanje,
                  false,
                  false,
                  false,
                  false,
                  flasiranje,
                  false,
                  false,
                  false,
                  true
                ];
                serverBus.$emit("disable_action", nizVrednosti);
              } else {
                let nizVrednosti = [
                  ulaz_grozdja,
                  ulaz_grozdja,
                  !presovanje,
                  false,
                  false,
                  false,
                  false,
                  flasiranje,
                  false,
                  false,
                  false,
                  true
                ];
                serverBus.$emit("disable_action", nizVrednosti);
              }
            } else {
              let nizVrednosti = [
                false,
                true,
                true,
                false,
                true,
                true,
                true,
                true,
                true,
                true,
                true,
                false
              ];
              serverBus.$emit("disable_action", nizVrednosti);
            }

            pomInt = i;
          }

          if (pomInt != 9999) tanks[pomInt].classList.add("active");
        }
      }

      this.tank_phase_vineId = tank.id;
      this.tankId = tank.tankId;
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/tank_phase_wine/room/" +
            this.idRoom,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items = response.data;
          if (this.items.length > 0)
            this.nazivProstorije = this.items[0].roomName;
          else this.getRoomName();
        })
        .catch((e) => {
          // // console.log(e.message);
          alert(1);
          // alert(this.$lang.general.greskaNaServeru);
        });
    },
    getRoomName() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/room/" + this.idRoom,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.nazivProstorije = response.data.name;
        })
        .catch((e) => {
          // // console.log(e.message);
          alert(1);
          // alert(this.$lang.general.greskaNaServeru);
        });
    },
  },
  watch: {
    $route() {
      this.idRoom = this.$route.params.id;

      this.getAllSifarnik();
    },
  },
  mounted() {
    serverBus.$off("ucitaj_podatke");

    this.idRoom = this.$route.params.id;

    this.getAllSifarnik();

    serverBus.$on("ucitaj_podatke", () => {
      // alert('ucitaj_podatke');

      this.getAllSifarnik();

      this.getAllSifarnik();

      let nizVrednosti = [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ];
      serverBus.$emit("disable_action", nizVrednosti);
    });
  },
  beforeCreate() {
    this.idRoom = this.$route.params.id;

    serverBus.$emit("fb", this.$route.params.id);
  },
};
</script>

<style scoped lang='scss'>
@import "../assets/sass/parts/_tanksRoom.scss";

.column {
  float: left;
}

.columnRight {
  float: right;
  color: #8e302f;
  font-weight: bold;
}

.columnVineType {
  float: left;
  text-align: left;
  margin-bottom: 0px;
}

.columnRightVineType {
  float: right;
  color: #018389;
  font-weight: bold;
  padding-left: 5px;
}

/* Clear floats after the columns */
.row:after {
  content: "";
  display: table;
  clear: both;
}
</style>
